import { http } from "./ky";
import type { Options } from "ky";

export type AuthErrorBody = {
  messages?: {
    error?: string;
  };
};

export type LoginRequest = {
  email?: string;
  password?: string;
  is_google_auth?: boolean;
};

export type LoginResponse = {
  orders: 0;
  access_token: string;
  expires_at: string;
};

export const login = async (
  data: LoginRequest,
  config?: Options
): Promise<LoginResponse> => {
  const response = await http.post("login", {
    json: data,
    ...config,
  });

  return await response.json<LoginResponse>();
};
